// extracted by mini-css-extract-plugin
export var center = "_1c-2";
export var clickableRow = "_1c-5";
export var expandedRow = "_1c-7";
export var hoverable = "_1c-4";
export var left = "_1c-1";
export var right = "_1c-3";
export var row = "_1c-0";
export var selectedRow = "_1c-6";
export var summaryRow = "_1c-8";